// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__2xVeD","label":"TextInput_label__2FcKI","details":"TextInput_details__3wt8U","input":"TextInput_input__293bh"};